import { z } from 'zod';

import { PropertyId } from '../../../BrandedIds';
import { PaymentCadenceEnum } from '../../../loan/EscrowSetting';
import { Checkbox, DateString, NonNegativeMonetaryValue } from '../../fields';

const SingleTaxTierFields = z.object({
  isEscrowed: Checkbox.optional(),
  amount: NonNegativeMonetaryValue.optional(),
  payeeName: z.string().optional(),
  nextDueDate: DateString.optional(),
  paymentCadence: PaymentCadenceEnum.optional(),
});

export type SingleTaxTierFields = z.infer<typeof SingleTaxTierFields>;

// County tax carries an extra countyName field — the county name flows to the property's
// address.county via maybeUpdateCounty in handleCreateEscrowSetting.
const SingleCountyTaxTierFields = SingleTaxTierFields.extend({
  countyName: z.string().optional(),
});

export type SingleCountyTaxTierFields = z.infer<typeof SingleCountyTaxTierFields>;

const SinglePropertyTaxFields = z.object({
  apn: z.string().optional(),
  county: SingleCountyTaxTierFields.optional(),
  city: SingleTaxTierFields.optional(),
  school: SingleTaxTierFields.optional(),
  other1: SingleTaxTierFields.optional(),
  other2: SingleTaxTierFields.optional(),
  other3: SingleTaxTierFields.optional(),
});

export const TAX_TIER_KEYS = ['county', 'city', 'school', 'other1', 'other2', 'other3'] as const;

export type TaxTierKey = (typeof TAX_TIER_KEYS)[number];

export const PrimaryPropertyTaxFields = z.object({
  address1Tax: SinglePropertyTaxFields.optional(),
});

const MultiSinglePropertyTaxFields = SinglePropertyTaxFields.extend({
  propertyId: PropertyId.optional(),
});

export const MultiPropertyTaxFields = z.object({
  address2Tax: MultiSinglePropertyTaxFields.optional(),
  address3Tax: MultiSinglePropertyTaxFields.optional(),
  address4Tax: MultiSinglePropertyTaxFields.optional(),
  address5Tax: MultiSinglePropertyTaxFields.optional(),
  address6Tax: MultiSinglePropertyTaxFields.optional(),
  address7Tax: MultiSinglePropertyTaxFields.optional(),
  address8Tax: MultiSinglePropertyTaxFields.optional(),
  address9Tax: MultiSinglePropertyTaxFields.optional(),
  address10Tax: MultiSinglePropertyTaxFields.optional(),
  address11Tax: MultiSinglePropertyTaxFields.optional(),
  address12Tax: MultiSinglePropertyTaxFields.optional(),
  address13Tax: MultiSinglePropertyTaxFields.optional(),
  address14Tax: MultiSinglePropertyTaxFields.optional(),
  address15Tax: MultiSinglePropertyTaxFields.optional(),
});
